import React from "react"
import { GetApp } from "../../App"
import { classNames } from "../../Components"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { IAccountPaymentSystem, IAccountSubscriptionStatus } from "../../Types"
import { AccountViewPlanBlockNonStripeProps } from "./Params"

const daysUntil = (iso: string): number =>
  Math.floor((Date.parse(iso).valueOf() - Date.now()) / (24 * 60 * 60 * 1000));

export function AccountViewPlanBlockNonStripe({ active, cancelCallback, canSubscribe: _canSubscribe, currency: _currency, plan }: AccountViewPlanBlockNonStripeProps) {
  const app = GetApp()!;
  const t = app.getT("AccountView");

  return (
    <Block className={classNames(["AccountView-plan", `AccountView-plan-${plan.plan.name}`, active && "active"])}>
      <BlockRow>
        <h2 className="AccountView-plan-name">{t(`plan_${plan.plan.name}`)}</h2>
      </BlockRow>
      <BlockRow>
        <LocalizedMessage message={(m) => m.planDescriptions[plan.plan.name]} className="AccountView-plan-description" />
      </BlockRow>

      {plan.features.filter((f) => f.amount != 0).map((f) => {
        let feature = null;
        switch (f.feature) {
          case "active_ships":
          case "active_users":
          case "active_tenders":
            feature = <BlockRow className="AccountView-plan-info">{t(`feature_${f.feature}`, { amount: (f.amount ?? 0) < 0 ? t("feature_unlimited") : (f.amount ?? 0) })}</BlockRow>;
            break;
          case "support":
            feature = <BlockRow className="AccountView-plan-info">{t(`feature_support_${f.amount}`)}</BlockRow>;
            break;
          default:
            return null;
        }
        return (
          <React.Fragment key={f.feature}>
            {feature}
          </React.Fragment>
        );
      })}

      {/* Prices and subscribe buttons hidden for iOS in-app view */}
      {active && plan.plan.id !== 1 && (
        <>
          {app.account && app.account.subscriptionStatus == IAccountSubscriptionStatus.cancelled ? (
            app.account.nextBillingAt && (
              <BlockRow>
                <BlockField>
                  <p><strong>{t("cancelled_ends", { days: daysUntil(app.account.nextBillingAt) })}</strong></p>
                </BlockField>
              </BlockRow>
            )
          ) : (
            <>
              {app.account && app.account.nextBillingAt && (
                <BlockRow>
                  <BlockField>
                    <p><strong>{t("renews_in", { days: daysUntil(app.account.nextBillingAt) })}</strong></p>
                  </BlockField>
                </BlockRow>
              )}
              {app.account?.paymentSystem !== IAccountPaymentSystem.gift && (
                <BlockRow actions={true} className="">
                  <BlockField>
                    <button onClick={() => cancelCallback()} className="button subscribe-button" disabled={!app.account}>{t("cancel_plan")}</button>
                  </BlockField>
                </BlockRow>
              )}
            </>
          )}
        </>
      )}
    </Block>
  );
}
